"use client";

import { PRODUCTS_TO_SHOW_CHECKOUT_INSTEAD_PQP } from "~/constants/quizFunnel";
import { useHasProductInCart } from "~/hooks/useHasProductInCart";
import { isFaceCreamCheckoutOverride } from "../cart";

/**
 * Hook form of the checkout-override rule for the DS quiz variants
 * (`componentsDS/Quiz` and `componentsDS/QuizRedesign`), which read the cart
 * from the Zustand store. Wraps the same rule as `hasFaceCreamInCart` so the
 * `category === FACE_CREAM` guard is not repeated at each call site.
 */
export const useHasFaceCreamInCart = (category: string): boolean =>
    isFaceCreamCheckoutOverride(
        category,
        useHasProductInCart(PRODUCTS_TO_SHOW_CHECKOUT_INSTEAD_PQP)
    );

export default useHasFaceCreamInCart;
